<micro-select-combo #sel
              placeholder="OAuth2 Grand Type"
              [mode]="mode"
              [(id)]="method"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched">
</micro-select-combo>
